<!-- <form (ngSubmit)="login()" class="kt-card-content flex flex-col gap-5 p-10">

<div class="flex flex-col gap-1">
<label class="kt-form-label">Email</label>
<input class="kt-input"
       type="email"
       [(ngModel)]="loginData.email"
       name="email"
       required>
</div>

<div class="flex flex-col gap-1">
<label class="kt-form-label">Password</label>
<input class="kt-input"
       type="password"
       [(ngModel)]="loginData.password"
       name="password"
       required>
</div>

<label class="kt-label">
<input type="checkbox"
       [(ngModel)]="loginData.rememberMe"
       name="rememberMe">
Remember me
</label>

<button class="kt-btn kt-btn-primary w-full" [disabled]="loading">
Sign In
</button>

<div *ngIf="error" class="text-red-500">
{{error}}
</div>

</form> -->


  <div class="flex items-center justify-center min-h-screen page-bg">
   <div class="kt-card max-w-[370px] w-full">
    <!-- <form action="#" class="kt-card-content flex flex-col gap-5 p-10" id="sign_in_form" method="get"> -->
    <form (ngSubmit)="login()" class="kt-card-content flex flex-col gap-5 p-10" method="post">
     <div class="text-center mb-2.5">
      <h3 class="text-lg font-medium text-mono leading-none mb-2.5">
       Sign in
      </h3>
      <!-- <div class="flex items-center justify-center font-medium">
       <span class="text-sm text-secondary-foreground me-1.5">
        Need an account?
       </span>
       <a class="text-sm link" href="html/demo1/authentication/classic/sign-up.html">
        Sign up
       </a>
      </div> -->
     </div>
     <div class="grid grid-cols-2 gap-2.5">
      <a class="kt-btn kt-btn-outline justify-center" href="#">
       <img alt="" class="size-3.5 shrink-0" src="assets/media/brand-logos/google.svg"/>
       Use Google
      </a>
      <a class="kt-btn kt-btn-outline justify-center" href="#">
       <img alt="" class="size-3.5 shrink-0 dark:hidden" src="assets/media/brand-logos/apple-black.svg"/>
       <img alt="" class="size-3.5 shrink-0 light:hidden" src="assets/media/brand-logos/apple-white.svg"/>
       Use Apple
      </a>
     </div>
     <div class="flex items-center gap-2">
      <span class="border-t border-border w-full">
      </span>
      <span class="text-xs text-muted-foreground font-medium uppercase">
       Or
      </span>
      <span class="border-t border-border w-full">
      </span>
     </div>
     <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">
       Username
      </label>
      <!-- <input class="kt-input" placeholder="email@email.com" type="text" value=""/> -->
      <input class="kt-input" type="email" [(ngModel)]="loginData.email" name="email" required> 
     </div>
     <div class="flex flex-col gap-1">
      <div class="flex items-center justify-between gap-1">
       <label class="kt-form-label font-normal text-mono">
        Password
       </label>
       <a class="text-sm kt-link shrink-0" href="html/demo1/authentication/classic/reset-password/enter-email.html">
        Forgot Password?
       </a>
      </div>
      <div class="kt-input" data-kt-toggle-password="true">
       <!-- <input name="user_password" placeholder="Enter Password" type="password" value=""/> -->
       <input class="kt-input" type="password" [(ngModel)]="loginData.password" name="password" required>
       <button class="kt-btn kt-btn-sm kt-btn-ghost kt-btn-icon bg-transparent! -me-1.5" data-kt-toggle-password-trigger="true" type="button">
        <span class="kt-toggle-password-active:hidden">
         <i class="ki-filled ki-eye text-muted-foreground">
         </i>
        </span>
        <span class="hidden kt-toggle-password-active:block">
         <i class="ki-filled ki-eye-slash text-muted-foreground">
         </i>
        </span>
       </button>
      </div>
     </div>
     <label class="kt-label">
      <!-- <input class="kt-checkbox kt-checkbox-sm" name="check" type="checkbox" value="1"/> -->
      <input type="checkbox" [(ngModel)]="loginData.rememberMe" name="rememberMe">
      <span class="kt-checkbox-label">
       Remember me
      </span>
     </label>
     <button class="kt-btn kt-btn-primary flex justify-center grow" [disabled]="loading">
      Sign In
     </button>

     <div *ngIf="error" class="text-red-500">
       {{error}}
     </div>
    </form>
   </div>
  </div>
  <!-- End of Page -->